import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "content-section" };
const _hoisted_2 = { class: "flex flex-wrap gap-5 text-black lg:gap-8" };
const _hoisted_3 = ["href"];
import SvgIcon from '@atoms/SvgIcon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ShareLinks',
    setup(__props) {
        const currentURL = window.location.href;
        const shareIconsData = [
            {
                name: 'facebook',
                url: 'https://www.facebook.com/sharer/sharer.php?u=',
            },
            {
                name: 'linkedin',
                url: 'https://www.linkedin.com/shareArticle?url=',
            },
        ];
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "mb-4 font-sans text-sm font-light" }, "Share", -1)),
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(shareIconsData, (icon) => {
                        return _createElementVNode("a", {
                            key: icon.name,
                            href: icon.url + _unref(currentURL),
                            class: "gtmSocialShare h-6 w-6 lg:h-9 lg:w-9",
                            rel: "noopener noreferrer",
                            target: "_blank"
                        }, [
                            _createVNode(SvgIcon, {
                                name: icon.name
                            }, null, 8, ["name"])
                        ], 8, _hoisted_3);
                    }), 64))
                ])
            ]));
        };
    }
});
